import { quickNavItems } from '@/mocks/home';

const toneMap: Record<string, { bg: string; text: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-800' },
};

export default function QuickNav() {
  const handleJump = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-wide text-primary-600 uppercase mb-3">
              <i className="ri-list-check-2"></i>
              核心关注点
            </span>
            <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl">
              大家最想弄清楚的问题，都在这里
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md">
            点击任意卡片即可跳到对应分区，按你的疑问顺序阅读，不必通篇翻找。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {quickNavItems.map((item) => {
            const tone = toneMap[item.tone] ?? toneMap.primary;
            return (
              <button
                key={item.id}
                type="button"
                onClick={() => handleJump(item.id)}
                className="group text-left p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <span className={`w-11 h-11 flex items-center justify-center rounded-md ${tone.bg} ${tone.text} mb-4`}>
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2 flex items-center gap-1">
                  {item.title}
                  <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}